import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import './style.scss';


registerBlockType( 'ps-s-custom-gutenberg-components/sample-block', {
    title: __( 'Static Block', 'ps-s-custom-gutenberg-components' ),
    icon: 'shield',
    category: 'common',
    edit() {
        return <p>{ __( 'Hello, World!', 'ps-s-custom-gutenberg-components' ) }</p>;
    },
    save() {
        return <p>{ __( 'Hello, World!', 'ps-s-custom-gutenberg-components' ) }</p>;
    },
} );

